import { getGameConfig } from '../../../shared/gameConfig';
import { IEraGameConfig } from '../../../shared/gameConfig/wowera/types';

export const gameConfig = getGameConfig<IEraGameConfig>();
